import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

export interface ConectarCajaModel {
    tipo: "conectar" | "asignar";
    idCaja: number;
    idCamion: number;
}

const TipoSelector = kea.defaultProps(kea.Select, {
    items:
    [
        { value: "conectar", label: "Conectar" },
        { value: "asignar", label: "Asignar" }
    ]
});

type Entity = ConectarCajaModel;
export interface Props extends kea.ModalProps<Entity, boolean, undefined> {
}

/**
 * Valida un ConectarCajaModel
 */
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        tipo: validation.required,
        idCaja: validation.required,
        idCamion: validation.required
    };
    return validation.getErrors(rules, x);
}

/**
* Modal de edición para un ConectarCajaModel
*/
export class ConectarCajaModelEdit extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    onGuardar = () => {
        this.props.onClose(true);
    };

    onCerrar = () => {
        this.props.onClose(false);
    }
    render() {
        const value = this.props.value;
        const getField = this.getField;
        const hasError = this.hasError(this.props);
        const Caja = getField(selectores.CajaRuta);
        const Camion = getField(selectores.Camion);
        const Tipo = getField(TipoSelector);
        return (
            <kea.Modal
                buttons={[<kea.GuardarButton onClick={this.onGuardar} disabled={hasError} />]}
                onClose={this.onCerrar}
                title="Conectar caja"
            >

                {kea.autogrid(4, [
                    <Tipo field="tipo" label="Tipo" />,
                    <Caja field="idCaja" label="Caja" />,
                    <Camion field="idCamion" label="Camión" />
                ])}
            </kea.Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/movimientoscajaruta/edit/conectar.tsx